import React, {useState, useContext} from 'react';
import Logo from "../../assets/logo v4.png"
import Avatar from '@mui/material/Avatar';
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../contexts/AuthContext';
import { useSelector } from "react-redux";
import user from '../../assets/user.png';
import edit from '../../assets/edit.png';
import { JoinActivityForm } from '../JoinActivityForm';
import EditProfileModal from '../EditProfileModal';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  IconButton, 
  Menu, 
  MenuItem, 
  Typography, 
  useMediaQuery, 
  useTheme,
  Tooltip,
  Divider
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import EditIcon from '@mui/icons-material/Edit';

function stringToColor(string) {
    if (!string) return '#000000'; // Return a default color if string is null or undefined
    
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
}
  
function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: name ? `${name.split('').map((char, index) => index > 0 ? char : '').join('')}` : '',
  };
}

export default function IndexPage_Navbar({callback_setActivities}) {
    const singOut = useSignOut();
    const navigate = useNavigate();
    const { logout: authLogout } = useContext(AuthContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const userName = localStorage.getItem('userName') || '匿名用戶';
    const email = localStorage.getItem('email')
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleOpenEditProfile = () => {
        setIsEditProfileOpen(true);
        setAnchorEl(null);
    };

    const handleCloseEditProfile = () => {
        setIsEditProfileOpen(false);
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };
  
    const logout = async () => {
       // Debug log
      
      try {
        // First clear all client-side data immediately
        
        
        // Clear AuthContext state
        await authLogout();
        
        // Clear react-auth-kit state
        singOut();
        
        // Clear all localStorage
        localStorage.clear();
        
        // Clear all sessionStorage
        sessionStorage.clear();
        
        // Clear all cookies
        const clearAllCookies = () => {
          const cookies = document.cookie.split(";");
          
          for (let cookie of cookies) {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            
            if (name) {
              // Clear cookie for current domain
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
              
              // Clear cookie for parent domain
              const domain = window.location.hostname;
              if (domain.includes('.')) {
                const parentDomain = '.' + domain.split('.').slice(-2).join('.');
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${parentDomain};`;
              }
              
              // Clear for localhost specifically
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=localhost;`;
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.localhost;`;
            }
          }
        };
        
        clearAllCookies();
        
        
        
        // Navigate to home
        navigate("/");
        
        // Force page reload to ensure complete state reset
        setTimeout(() => {
          window.location.reload();
        }, 100);
        
      } catch (error) {
        console.error('Logout error:', error);
        // Even if there's an error, still clear client data and navigate
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        window.location.reload();
      }
    };

    return (
      <>
        <AppBar position="static" color="default" elevation={0} sx={{ backgroundColor: 'var(--primary-color)', height: '80px' }}>
            <Toolbar sx={{ minHeight: '80px !important', height: '80px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img alt='' src={Logo} style={{ width: isMobile ? '60px' : '85px', height: isMobile ? '60px' : '85px' }} />
                </Box>

                {isMobile ? (
                    <>
                        <Box sx={{ flexGrow: 1 }} />
                        <IconButton
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            onClick={toggleMobileMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                    </>
                ) : (
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 2, 
                        ml: 'auto',
                        flexWrap: 'nowrap'
                    }}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            startIcon={<ListAltIcon />}
                            onClick={() => navigate("/teacher/home")}
                            sx={{ 
                                borderRadius: '50px',
                                backgroundColor: '#E3DFFD',
                                '&:hover': { backgroundColor: '#D1CCF9' },
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 2,
                                height: '40px',
                                color: '#000000'
                            }}
                        >
                            查看我創建的活動
                        </Button>
                        
                        <Button 
                            variant="contained" 
                            color="secondary" 
                            startIcon={<PersonAddIcon />}
                            sx={{ 
                                borderRadius: '50px',
                                backgroundColor: '#ECC6FA',
                                '&:hover': { backgroundColor: '#DDB5F0' },
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 2,
                                height: '40px',
                                color: '#000000'
                            }}
                        >
                            <JoinActivityForm callback_setActivities={callback_setActivities}/>
                        </Button>
                        
                        <Tooltip title="個人選項">
                            <IconButton
                                onClick={handleMenuOpen}
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                color="inherit"
                            >
                                <Avatar {...stringAvatar(name)} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            </Toolbar>
        </AppBar>

        {/* Mobile Menu */}
        {isMobile && mobileMenuOpen && (
            <Box sx={{ 
                position: 'absolute', 
                top: '64px', 
                right: 0, 
                width: '100%', 
                backgroundColor: 'var(--primary-color)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                zIndex: 1000,
                p: 2
            }}>
                <Button 
                    fullWidth 
                    variant="contained" 
                    color="primary" 
                    startIcon={<ListAltIcon />}
                    onClick={() => navigate("/teacher/home")}
                    sx={{ 
                        borderRadius: '50px',
                        backgroundColor: '#E3DFFD',
                        '&:hover': { backgroundColor: '#D1CCF9' },
                        textTransform: 'none',
                        fontWeight: 600,
                        mb: 1,
                        color: '#000000'
                    }}
                >
                    查看我創建的活動
                </Button>
                
                <Button 
                    fullWidth 
                    variant="contained" 
                    color="secondary" 
                    startIcon={<PersonAddIcon />}
                    sx={{ 
                        borderRadius: '50px',
                        backgroundColor: '#ECC6FA',
                        '&:hover': { backgroundColor: '#DDB5F0' },
                        textTransform: 'none',
                        fontWeight: 600,
                        mb: 1,
                        color: '#000000'
                    }}
                >
                    <JoinActivityForm callback_setActivities={callback_setActivities}/>
                </Button>
                
                <Divider sx={{ my: 1 }} />
                
                <Button 
                    fullWidth 
                    variant="outlined" 
                    startIcon={<EditIcon />}
                    onClick={handleOpenEditProfile}
                    sx={{ 
                        borderRadius: '50px',
                        borderColor: '#ECC6FA',
                        color: '#000000',
                        '&:hover': { 
                            borderColor: '#A0B9FF',
                            backgroundColor: '#F5F8FF'
                        },
                        textTransform: 'none',
                        fontWeight: 600,
                        mb: 1
                    }}
                >
                    編輯個人資料
                </Button>
                
                <Button 
                    fullWidth 
                    variant="outlined" 
                    startIcon={<LogoutIcon />}
                    onClick={logout}
                    sx={{ 
                        borderRadius: '50px',
                        borderColor: '#ECC6FA',
                        color: '#000000',
                        '&:hover': { 
                            borderColor: '#A0B9FF',
                            backgroundColor: '#F5F8FF'
                        },
                        textTransform: 'none',
                        fontWeight: 600
                    }}
                >
                    登出
                </Button>
            </Box>
        )}

        {/* User Menu */}
        <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
                sx: {
                    mt: 1.5,
                    borderRadius: 2,
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    minWidth: 200
                }
            }}
        >
            <Box sx={{ px: 2, py: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                    嗨！{userName}
                </Typography>
            </Box>
            <Divider />
            <MenuItem onClick={handleOpenEditProfile} sx={{ py: 1 }}>
                <EditIcon fontSize="small" sx={{ mr: 1 }} />
                <Typography>編輯個人資料</Typography>
            </MenuItem>
            <MenuItem onClick={logout} sx={{ py: 1 }}>
                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                <Typography>登出</Typography>
            </MenuItem>
        </Menu>

        <EditProfileModal open={isEditProfileOpen} onClose={handleCloseEditProfile} />
      </>
    )
}